import { render } from "./EngineeringDetail.vue?vue&type=template&id=50d76768&scoped=true&ts=true&lang=pug"
import script from "./EngineeringDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./EngineeringDetail.vue?vue&type=script&lang=ts&setup=true"

import "./EngineeringDetail.vue?vue&type=style&index=0&id=50d76768&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d76768"]])

export default __exports__